module.exports = __webpack_public_path__ + "f134043b9122e1d03af503ed7727df80.png";